/**
 * The metric list a formula builder offers. The Flow Optimizer fetches its
 * metadata; another feature (the Drop Generator's hour formula) provides
 * its own catalog through this context and the builders render unchanged —
 * the metadata query is simply not started while a catalog is provided.
 * For Media Devoted | Created By Ciro Autiero
 */
import { createContext, FC, ReactNode, useContext } from 'react';
import type { FlowOptimizerMetricMeta } from '@trafficpulse/shared';

import { useFlowOptimizerMetadata } from '../../../hooks';

const CatalogContext = createContext<FlowOptimizerMetricMeta[] | null>(null);

export const FormulaMetricCatalogProvider: FC<{
  metrics: FlowOptimizerMetricMeta[];
  children: ReactNode;
}> = ({ metrics, children }) => (
  <CatalogContext.Provider value={metrics}>{children}</CatalogContext.Provider>
);

export interface FormulaMetricCatalog {
  data?: { metrics: FlowOptimizerMetricMeta[] };
}

export function useFormulaMetricCatalog(): FormulaMetricCatalog {
  const provided = useContext(CatalogContext);
  const metadata = useFlowOptimizerMetadata('voluum', { enabled: provided === null });
  return provided ? { data: { metrics: provided } } : metadata;
}
